import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isSending, setIsSending] = useState(false);

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    const name = formData.name.trim();
    const email = formData.email.trim();
    const message = formData.message.trim();

    if (!name || !email || !message) {
      setStatus("Please fill in all fields.");
      return;
    }

    if (!EMAIL_REGEX.test(email)) {
      setStatus("Please enter a valid email address.");
      return;
    }

    const serviceID =
      process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_k95r3p5";
    const templateID =
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "template_9w53qwu";
    const publicKey =
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "7B0B0AIQ0_vGt34Tg";

    if (!serviceID || !templateID || !publicKey) {
      setStatus("Email configuration is missing. Please check EmailJS keys.");
      return;
    }

    setIsSending(true);
    try {
      await emailjs.send(
        serviceID,
        templateID,
        {
          from_name: name,
          from_email: email,
          message,
          to_name: "Nishant Chaudhary",
          reply_to: email,
        },
        publicKey
      );

      setStatus("Thank you for reaching out! Your message has been sent.");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      const details = error?.text || error?.message || "Unknown error";
      setStatus(`Unable to send message right now. ${details}`);
      console.error("EmailJS send failed:", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contact-section py-5" id="contact">
      <h2 className="text-center mb-3">Contact Me</h2>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="3"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Submit"}
              </button>
            </form>
            {status && <div className="mt-3">{status}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
